import { Button, Paper, TextField } from "@material-ui/core";
import { styled } from "@material-ui/core";

export const StyledButtonSignIn = styled(Button)({
  lineHeight: 1,
  width: "100%",
  cursor: "pointer",
  borderRadius: "6px",
  backgroundColor: "#4285f4",
  letterSpacing: "var(--letter-spacing-0px)",
  fontSize: "1.313rem",
  fontWeight: "bold",
  color: "#fff",
  outline: "none",
  border: "none",
  padding: "0.875rem 8px",
  textTransform: "none",
  marginTop: "5%",
  "&:hover": {
    backgroundColor: "#246ce4",
  },
  "&:disabled": {
    color: "var(--gray-disabled)",
    boxShadow: "none",
    backgroundColor: "var(--gray-disabled-bg)",
  },
});

export const StyledButtonGitHub = styled(Button)({
  lineHeight: 1,
  width: "100%",
  cursor: "pointer",
  borderRadius: "6px",
  backgroundColor: "#000000d1",
  letterSpacing: "var(--letter-spacing-0px)",
  fontSize: "1.313rem",
  fontWeight: "bold",
  color: "#fff",
  outline: "none",
  border: "none",
  textTransform: "none",
  padding: "0.875rem 0.5rem",
  "&:hover": {
    background: "#000000",
  },
});

export const StyledMainDiv = styled("div")({
  position: "relative",
  textAlign: "center",
  top: "4%",
});

export const StyledPaper = styled(Paper)({
  width: "60%;",
  background: "#ffffffd4",
  boxShadow: "#0000005e 0 0 6px",
  margin: "auto",
  marginTop: "10%",
  position: "relative",
  top: "30%",
  borderRadius: "0.9375rem",
  padding: "2.5rem 5rem 5rem",
  "@media (max-width:820px)": {
    width: "90%",
    padding: "1.625rem 1.875rem 2.5rem ",
  },
});

export const StyledTextField = styled(TextField)({
  width: "100%",
  marginTop: "0.6vw",
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    padding: "6px 30px",
  },
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#4285f4",
  },
  "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#4285f4",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#4285f4",
  },
});

export const StyledNewUserDiv = styled("div")({
  paddingTop: "20px",
  textAlign: "center",
  fontSize: "1rem",
  "& a": {
    color: "#4285F4",
    fontWeight: "700",
    cursor: "pointer",
  },
});

export const StyledFormDataRememberAndForgotDiv = styled("div")({
  width: "100%",
  paddingTop: "15px",
  "& label": {
    float: "left",
    "& .MuiTypography-body1": {
      color: "#5C5E5D",
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "#4285f4",
    },
  },
  "& a": {
    float: "right",
    padding: "9px 0",
    color: "#1768ED",
    fontSize: "1rem",
  },
});

export const StyledDivider = styled("h2")({
  width: "100%",
  textAlign: "center",
  borderBottom: "0.0625rem solid black",
  lineHeight: "0.2em",
  marginTop: "1.875rem",
  marginBottom: "1.5625rem",
  "& span": {
    background: "#fff",
    padding: "0rem 0.625rem",
    fontWeight: "bold",
    fontSize: "1.25rem",
  },
});
